import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import TemplateTag from "../../code/models/TemplateTag";
import { Editor as TinyMCEEditor } from "tinymce/tinymce";
import RegisterPlugins from "./register-plugins";
import { TextTemplateInfo } from "./TextTemplatePlugin";
import { TextTemplateButtonInfo } from "./TextTemplateButtonPlugin";

interface IEmailEditor {
    onChange(value: string): void;
    initialValue: string;
    templateTags?: TemplateTag[] | undefined;
    textTemplates?: TextTemplateInfo[] | undefined;
    templateButtons?: TextTemplateButtonInfo[] | undefined;
    previewMode: boolean | undefined;
}

export default function EmailEditor({ onChange, initialValue, templateTags, textTemplates, templateButtons, previewMode }: IEmailEditor) {
    const emailEditorRef = React.useRef<any>(null);

    function getMessage(): string {
        if (emailEditorRef.current) {
            return emailEditorRef.current.getContent();
        } else {
            return "";
        }
    }

    function handleOnChange(): void {
        onChange(getMessage());
    }

    function getPluginList(): string[] {
        var plugins: string[] = [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
        ];
        return plugins;
    }

    function getCustomToolbar(): string | undefined {
        let result: string[] = [];
        if (!!templateButtons) {
            for (let i = 1; i <= templateButtons.length; i++) {
                result.push(`templatebutton_${i}`);
            }
        }
        if (!!templateTags) {
            result.push("templatetags");
        }
        if (!!textTemplates) {
            result.push("texttemplates");
        }
        if (result.length > 0) {
            return result.join(" | ");
        }
    }

    const setup = React.useCallback((editor: TinyMCEEditor) => {
        if (!!editor) {
            RegisterPlugins(editor);
        }
    }, []);

    function buildInit(): any {
        var result: any = {
            setup,
            resize: false,
            paste_data_images: true,
            menubar: 'edit insert view format table',
            plugins: getPluginList()
        };
        let tb2 = getCustomToolbar();
        if (!!tb2) {
            result.toolbar1 = 'undo redo | fontsize | preview | bold italic forecolor backcolor | alignleft aligncenter alignright | bullist numlist outdent indent';
            result.toolbar2 = tb2;
        } else {
            result.toolbar = 'undo redo | fontsize | preview | bold italic forecolor backcolor | alignleft aligncenter alignright | bullist numlist outdent indent';
        }
        if (!!templateTags) {
            result["variable_button_text"] = "Template Tags";
            result["variable_list"] = templateTags.map((tt) => {
                return {
                    text: tt.text,
                    tag: tt.tag,
                    children: []
                };
            });
        }
        if (!!textTemplates) {
            result["texttemplate_button_text"] = "Quick Notes";
            result["texttemplate_items"] = textTemplates;
        }
        if (!!templateButtons) {
            result["template_buttons"] = templateButtons;
        }

        return result;
    }

    function onEditorInit(evt: any, editor: any) {
        emailEditorRef.current = editor;
        editor?.getBody()?.setAttribute('spellcheck', true);
    }

    return (
        <React.Fragment>
            {!previewMode && <Editor ref={emailEditorRef}
                apiKey="2cfjyoa4nf43zbt1jbc9hylhacefex5wue69ds4q5mliq7ys"
                onInit={onEditorInit}
                onChange={() => handleOnChange()}
                initialValue={initialValue}
                init={buildInit()}
            />}

            {!!previewMode && <Editor ref={emailEditorRef}
                apiKey="2cfjyoa4nf43zbt1jbc9hylhacefex5wue69ds4q5mliq7ys"
                onInit={(evt, editor) => emailEditorRef.current = editor}
                initialValue={initialValue}
                disabled={true}
                init={{
                    resize: false,
                    paste_data_images: true,
                    menubar: false,
                    plugins: [],
                    toolbar: false
                }}
            />}
        </React.Fragment>
    )
}

